/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { Filter3 } from "./modelFilter3";

class ControllerFilter3 extends ControllerModel {
    constructor() {
        super("ControllerFilter3");

        this.setNewNode = (callback) => {
            let filter3 = new Filter3();
            filter3.decorate(callback);

            this.addNode(filter3);
            SingletonFlowchart.SaveStatus()
        }

        this.loadNode = (node, callback) => {
            let filter3 = new Filter3();
            filter3.copyFrom(node);
            filter3.decorate(callback);
            this.addNode(filter3)
        }

        this.getProperties = async (node) => {
            let n = new Filter3();
            await n.copyFrom(node);
            return n.data
        }

        this.getNode = (node) => {
            let n = new Filter3();
            n.copyFrom(node);
            return n
        }
    }
}

export { ControllerFilter3 };